import { useQuery } from '@graphcommerce/graphql'
import { Maybe } from '@graphcommerce/graphql-mesh'
import { ProductListFiltersContainer, SearchDivider } from '@graphcommerce/magento-search'
import { StoreConfigDocument } from '@graphcommerce/magento-store'
import { StickyBelowHeader } from '@graphcommerce/next-ui'
import { i18n } from '@lingui/core'
import { Container } from '@mui/material'
import algoliasearch from 'algoliasearch/lite'
// eslint-disable-next-line import/no-named-default
import { default as SingletonRouterInstance } from 'next/router'
import { InstantSearch as InstantSearchBase, Configure } from 'react-instantsearch-hooks-web'
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs'
import { AlgoliaPagination } from '../AlgoliaPagination'
import { CustomHitsPerPage } from '../CustomHitsPerPage'
import { CustomRefinementList } from '../CustomRefinementList'
import { RefinementSlider } from '../RefinementSlider'
import { ResultsList } from '../Results/ResultsList'
import { SearchBox } from '../SearchBox'

export function InstantSearch({ query }: { query: Maybe<string> | undefined }) {
  const appId = import.meta.graphCommerce.algoliaApplicationId
  const apiKey = import.meta.graphCommerce.algoliaSearchOnlyKey
  const searchClient = algoliasearch(appId, apiKey)
  const { data: config } = useQuery(StoreConfigDocument)
  const storeCode = config?.storeConfig?.store_code ?? 'b2c_en'
  const searchIndex = `magento2_${storeCode}_products`

  return (
    <InstantSearchBase
      searchClient={searchClient}
      indexName={searchIndex}
      routing={{
        router: createInstantSearchRouterNext({
          singletonRouter: SingletonRouterInstance,
          routerOptions: {
            cleanUrlOnDispose: false,
          },
        }),
      }}
      initialUiState={{
        [searchIndex]: {
          query: query ?? '',
          page: 1,
        },
      }}
      // prevents double queries from running when text inside searchbox changes.
      onStateChange={({ uiState, setUiState }) => setUiState(uiState)}
    >
      <Configure hitsPerPage={20} />

      <Container maxWidth='lg'>
        <SearchBox />
        <SearchDivider />
      </Container>
      <StickyBelowHeader>
        <ProductListFiltersContainer>
          <RefinementSlider attribute='price.EUR.default' title={i18n._(/* i18n */ 'Price')} />
          <CustomRefinementList
            attribute='categories.level0'
            title={i18n._(/* i18n */ 'Category')}
            sortBy={['name:asc']}
          />
          <CustomRefinementList attribute='merk' title={i18n._(/* i18n */ 'Brand')} />
          <CustomRefinementList attribute='soort' title={i18n._(/* i18n */ 'Type')} />
          <CustomHitsPerPage />
        </ProductListFiltersContainer>
      </StickyBelowHeader>

      <Container maxWidth={false}>
        <ResultsList />
        <AlgoliaPagination />
      </Container>
    </InstantSearchBase>
  )
}
